module.exports = __webpack_public_path__ + "img/gift-lunch.989a195a.svg";